<template>
  <div>
    <router-view />
  </div>
</template>

<style lang="scss">
@import "@/assets/reset.scss";
</style>
